export default {"title":"subpath-example"};